// This file is auto-generated by bin/stimulus-manifest-watcher
// Do not edit manually - changes will be overwritten

import { application } from "./application"

// Controllers from app/javascript/controllers/
import AdminToggleController from "./admin_toggle_controller"
import AdminToolStatusController from "./admin_tool_status_controller"
import ArchiveReasonController from "./archive_reason_controller"
import AutoSubmitController from "./auto_submit_controller"
import AutocompleteController from "./autocomplete_controller"
import BootstrapModalController from "./bootstrap_modal_controller"
import CartController from "./cart_controller"
import CartItemUpdateController from "./cart_item_update_controller"
import CartNameEditController from "./cart_name_edit_controller"
import CartQuantityController from "./cart_quantity_controller"
import CartSaveController from "./cart_save_controller"
import CartShareController from "./cart_share_controller"
import CartSwitchConfirmController from "./cart_switch_confirm_controller"
import CheckoutController from "./checkout_controller"
import ClickableRowController from "./clickable_row_controller"
import CompareHighlightController from "./compare_highlight_controller"
import ContactFormController from "./contact_form_controller"
import CopyPromptController from "./copy_prompt_controller"
import CustomerNumberCheckController from "./customer_number_check_controller"
import FeedbackModalController from "./feedback_modal_controller"
import FilterController from "./filter_controller"
import FlashController from "./flash_controller"
import FocusOnLoadController from "./focus_on_load_controller"
import GlossarySearchController from "./glossary_search_controller"
import ImagePreviewController from "./image_preview_controller"
import LinkCheckController from "./link_check_controller"
import LinkCheckerController from "./link_checker_controller"
import LocationLookupController from "./location_lookup_controller"
import LocationRowsController from "./location_rows_controller"
import LocationsController from "./locations_controller"
import MobileNavigationController from "./mobile_navigation_controller"
import OnlineDealerFormController from "./online_dealer_form_controller"
import OnlineDealerTabsController from "./online_dealer_tabs_controller"
import ParticlesController from "./particles_controller"
import PasswordResetController from "./password_reset_controller"
import PasswordValidatorController from "./password_validator_controller"
import PrintWindowController from "./print_window_controller"
import RankingMapController from "./ranking_map_controller"
import RememberedCollapseController from "./remembered_collapse_controller"
import SearchResultsController from "./search_results_controller"
import SearchableCheckboxesController from "./searchable_checkboxes_controller"
import ShowAllController from "./show_all_controller"
import SizeComparisonController from "./size_comparison_controller"
import SizeTypeSelectorController from "./size_type_selector_controller"
import SizeUniquenessController from "./size_uniqueness_controller"
import SponsorshipFormController from "./sponsorship_form_controller"
import SwipeController from "./swipe_controller"
import ToggleVisibilityController from "./toggle_visibility_controller"
import UserPermissionsController from "./user_permissions_controller"
import VideoModalController from "./video_modal_controller"
import WhnExamplePreviewController from "./whn_example_preview_controller"
import WhnFormController from "./whn_form_controller"
import WhnLinkTypeController from "./whn_link_type_controller"
import YoutubePlayerController from "./youtube_player_controller"

// Controllers from app/javascript/features/
import ShippingCostsController from "../features/checkouts/controllers/shipping-costs-controller.js"
import ShippingLoadingController from "../features/checkouts/controllers/shipping-loading-controller.js"
import ConversionTableController from "../features/conversion_table/controller/conversion_table_controller.js"
import KeywordController from "../features/keywords/controllers/keyword-controller.js"
import ComparisonWidgetController from "../features/product-comparison/controllers/comparison-widget-controller.js"
import ColorPickerController from "../features/product_lines/controllers/color-picker-controller.js"
import HeatshrinkKitController from "../features/product_lines/controllers/heatshrink-kit-controller.js"
import NonSleevingFormController from "../features/product_lines/controllers/non-sleeving-form-controller.js"
import ProductSelectionController from "../features/product_lines/controllers/product-selection-controller.js"
import SizePickerController from "../features/product_lines/controllers/size-picker-controller.js"
import StylePickerController from "../features/product_lines/controllers/style-picker-controller.js"
import UnitToggleController from "../features/product_lines/controllers/unit-toggle-controller.js"
import ValueAddedController from "../features/product_lines/controllers/value-added-controller.js"
import SleevingSelectorController from "../features/sleeving_selector/controller/sleeving_selector_controller.js"
import TooltipController from "../features/tooltips/tooltip-controller.js"

// Register controllers from app/javascript/controllers/
application.register("admin-toggle", AdminToggleController)
application.register("admin-tool-status", AdminToolStatusController)
application.register("archive-reason", ArchiveReasonController)
application.register("auto-submit", AutoSubmitController)
application.register("autocomplete", AutocompleteController)
application.register("bootstrap-modal", BootstrapModalController)
application.register("cart", CartController)
application.register("cart-item-update", CartItemUpdateController)
application.register("cart-name-edit", CartNameEditController)
application.register("cart-quantity", CartQuantityController)
application.register("cart-save", CartSaveController)
application.register("cart-share", CartShareController)
application.register("cart-switch-confirm", CartSwitchConfirmController)
application.register("checkout", CheckoutController)
application.register("clickable-row", ClickableRowController)
application.register("compare-highlight", CompareHighlightController)
application.register("contact-form", ContactFormController)
application.register("copy-prompt", CopyPromptController)
application.register("customer-number-check", CustomerNumberCheckController)
application.register("feedback-modal", FeedbackModalController)
application.register("filter", FilterController)
application.register("flash", FlashController)
application.register("focus-on-load", FocusOnLoadController)
application.register("glossary-search", GlossarySearchController)
application.register("image-preview", ImagePreviewController)
application.register("link-check", LinkCheckController)
application.register("link-checker", LinkCheckerController)
application.register("location-lookup", LocationLookupController)
application.register("location-rows", LocationRowsController)
application.register("locations", LocationsController)
application.register("mobile-navigation", MobileNavigationController)
application.register("online-dealer-form", OnlineDealerFormController)
application.register("online-dealer-tabs", OnlineDealerTabsController)
application.register("particles", ParticlesController)
application.register("password-reset", PasswordResetController)
application.register("password-validator", PasswordValidatorController)
application.register("print-window", PrintWindowController)
application.register("ranking-map", RankingMapController)
application.register("remembered-collapse", RememberedCollapseController)
application.register("search-results", SearchResultsController)
application.register("searchable-checkboxes", SearchableCheckboxesController)
application.register("show-all", ShowAllController)
application.register("size-comparison", SizeComparisonController)
application.register("size-type-selector", SizeTypeSelectorController)
application.register("size-uniqueness", SizeUniquenessController)
application.register("sponsorship-form", SponsorshipFormController)
application.register("swipe", SwipeController)
application.register("toggle-visibility", ToggleVisibilityController)
application.register("user-permissions", UserPermissionsController)
application.register("video-modal", VideoModalController)
application.register("whn-example-preview", WhnExamplePreviewController)
application.register("whn-form", WhnFormController)
application.register("whn-link-type", WhnLinkTypeController)
application.register("youtube-player", YoutubePlayerController)

// Register controllers from app/javascript/features/
application.register("shipping-costs", ShippingCostsController)
application.register("shipping-loading", ShippingLoadingController)
application.register("conversion-table", ConversionTableController)
application.register("keyword", KeywordController)
application.register("comparison-widget", ComparisonWidgetController)
application.register("color-picker", ColorPickerController)
application.register("heatshrink-kit", HeatshrinkKitController)
application.register("non-sleeving-form", NonSleevingFormController)
application.register("product-selection", ProductSelectionController)
application.register("size-picker", SizePickerController)
application.register("style-picker", StylePickerController)
application.register("unit-toggle", UnitToggleController)
application.register("value-added", ValueAddedController)
application.register("sleeving-selector", SleevingSelectorController)
application.register("tooltip", TooltipController)
